import { isArray } from 'lodash';
import moment from 'moment';
import { handleActions } from 'redux-actions';
import * as actions from 'src/reducers/Cotizacion/cotizacion.actions';

export const OPCIONES_PAGO = {
  NINGUNA: 'NINGUNA',
  SELECCIONAR: 'SELECCIONAR',
  REDIRECCIONAR_BIEN: 'REDIRECCIONAR_BIEN',
  EXTERNA: 'EXTERNA',
};

export const OPCIONES_VIGENCIA = {
  MANUAL: 'MANUAL',
  AUTOMATICO: 'AUTOMATICO',
  NO_CAPTURAR: 'NO',
  INICIO_FIN: 'INICIO_FIN',
};

const initialState = {
  cotizacion: null,
  loadingCotizacion: false,
};

const setCotizacionState = (state, { payload: cotizacion }) => {
  //
  //   cotizacion.transaccionesPendientesPTP.push({
  //     valoresPagar: {
  //       subtotal: 110,
  //       impuestos: 110,
  //       total: 110,
  //     },
  //     productoNombre: 'Cupo Seguros',
  //     traMonto: 20062,

  //   });
  //

  // if (cotizacion.valoresPagar && cotizacion.valoresPagar.total) {
  //   const { total } = cotizacion.valoresPagar;
  //   cotizacion.pagar = {
  //     total: Math.round(100 * total) / 100,
  //   };
  //   cotizacion.valoresPagar.total = Math.round(100 * total) / 100;
  // }
  cotizacion.disabledPagoPendientePtp = cotizacion.cotEstado === 'PN';
  cotizacion.flujoPlugin = `${cotizacion.flujoPlugin}`;

  function formatTwoDecimalsWithoutRounding(number) {
    const numberAsString = number.toString();
    const parts = numberAsString.split('.');
    let formattedNumber = parts[0]; // Parte entera
  
    if (parts.length > 1) {
      // Si hay parte decimal, toma solo los dos primeros decimales
      formattedNumber += '.' + parts[1].slice(0, 2);
    } else {
      // Si no hay parte decimal, agrega ".00"
      formattedNumber += '.00';
    }
  
    return formattedNumber;
  }

  if (!cotizacion.styles?.pages) {
    cotizacion.styles = {
      pages: {
        home: {
          btnSeleccionoProducto: ``,
          globalStyles: `
          .footer_button__continuar{
            width: 100%;
            border: 1px solid #50a0da;
            background-color: #50a0da;
            padding: 0.8rem 0rem;
            border-radius: 20px;
            color: white;
            font-weight: 500;
            font-size: 1.5rem;
            outline: none !important;
            &:hover {
              background-color: #50a0da;
            }
            
            &:disabled {
              background-color: black;
            }
        
          }
          `,
        },
        preview: {
          btnAquirir: ``,
          globalStyles: ``,
        },
        registroTitular: {
          globalStyles: ``,
        },
        paginaCompra: {
          btnGuardar: ``,
          btnContinuar: ``,
          globalStyles: ``,
        },
        paginaPago: {
          globalStyles: ``,
        },
        pagoPlaceToPay: {
          globalStyles: ``,
        },
        firmarPolizaEv: {
          globalStyles: ``,
        },
        finCompra: {
          globalStyles: ``,
        },
      },
    };
  }

  cotizacion.tieneAseguradora = false;
  cotizacion.tieneCanalComercial = false;
  cotizacion.tieneHeader = false;

  if (cotizacion?.aseguradora?.urlLogo) {
    cotizacion.tieneAseguradora = true;
    cotizacion.tieneHeader = true;
  }

  if (cotizacion?.canalComercial?.urlLogo) {
    cotizacion.tieneCanalComercial = true;
    cotizacion.tieneHeader = true;
  }

  if (cotizacion.terminosCondiciones && cotizacion.terminosCondiciones.activo) {
    cotizacion.tieneTerminosCondiciones = true;
    cotizacion.urlTerminosCondiciones = cotizacion.terminosCondiciones.url;
  } else {
    cotizacion.tieneTerminosCondiciones = false;
  }

  cotizacion.opcionPago = '';

  if (cotizacion?.valoresPagar?.total) {
    const total = parseFloat(cotizacion?.valoresPagar?.total);
    cotizacion.valoresPagar.total = total.toFixed(2)
    cotizacion.opcionPago = OPCIONES_PAGO.SELECCIONAR;

    if (total === 0) {
      cotizacion.opcionPago = OPCIONES_PAGO.NINGUNA;
    }
    cotizacion.pagar = {
      ...cotizacion.valoresPagar,
    };
  }

  if (cotizacion?.producto?.formaPago === 'ninguna' || (cotizacion.hasOwnProperty('tieneCredito') && cotizacion.tieneCredito === true)) {
    cotizacion.opcionPago = OPCIONES_PAGO.NINGUNA;
  }
  if (cotizacion?.producto?.formaPago === 'externa') {
    cotizacion.opcionPago = OPCIONES_PAGO.EXTERNA;
  }

  if (cotizacion?.configuracion?.credencialesPtp?.empCodigo) {
    cotizacion.empPtp = cotizacion?.configuracion?.credencialesPtp.empCodigo;
  } else {
    switch (cotizacion.flujoPlugin) {
      case '6':
        break;
      case '7':
        cotizacion.empPtp = cotizacion.producto.codigoCore;
        break;
      case '9':
        cotizacion.empPtp = cotizacion.producto.codigoCore;
        break;

      case '10':
        if (!cotizacion?.responseCoverme) {
          cotizacion.opcionPago = OPCIONES_PAGO.REDIRECCIONAR_BIEN;
        }
        break;

      default:
        break;
    }

    cotizacion.capturaVigencia = OPCIONES_VIGENCIA.AUTOMATICO;
    const fechaVigenciaFechaPago = cotizacion?.producto?.fechaVigenciaFechaPago;
    // if (typeof fechaVigenciaFechaPago === 'string') {
    if (`${fechaVigenciaFechaPago}` === `` || fechaVigenciaFechaPago === '0') {
      cotizacion.capturaVigencia = OPCIONES_VIGENCIA.MANUAL;
    }
  }

  // segUsuarioEditaVigencia verifica si la cotizacio puede igresar la fecha de fi
  if (`${cotizacion?.producto?.segUsuarioEditaVigencia}` === '1') {
    cotizacion.capturaVigencia = OPCIONES_VIGENCIA.INICIO_FIN;
  }

  //establece el iicio de vigecia al dia actual

  // if (cotizacion.inicioVigencia) {
  if (cotizacion.inicioVigencia && !isArray(cotizacion?.inicioVigencia)) {
    cotizacion.inicioVigencia = moment(cotizacion.inicioVigencia, 'DD/MM/yyyy').toDate();
  } else {
    cotizacion.inicioVigencia = moment(new Date(), 'DD/MM/yyyy').toDate(); //sergio dijo que haga asi porque la pame le dijo a el
  }

  if (cotizacion.finVigencia) {
    cotizacion.finVigencia = moment(cotizacion.finVigencia, 'DD/MM/yyyy').toDate();
  } else {
    cotizacion.finVigencia = null;
    // cotizacion.finVigencia = moment(new Date(), 'DD/MM/yyyy').toDate(); //sergio dijo que haga asi
  }

  if (cotizacion?.producto) {
    cotizacion.producto = {
      ...cotizacion?.producto,
      numBeneficiarios: Number(cotizacion?.producto?.numBeneficiarios),
    };
    if (cotizacion?.producto?.numBeneficiarios === 0) {
      cotizacion.beneficiarioIgualTitular = true; // Establece en true si en el backoffice los beneficiarios es === 0
    }
  }

  cotizacion.historialPago = cotizacion?.historialPago ?? [];

  // console.log('COTIZACION: ', cotizacion?.producto?.categoria);

  return { ...state, cotizacion: { ...cotizacion }, loadingCotizacion: false };
};

const setBeneficiarioIgualTitular = (state, { payload: checked }) => {
  state.cotizacion.beneficiarioIgualTitularChecked = checked;

  return { ...state, loadingCotizacion: false };
};

const Cotizacion = handleActions(
  {
    [actions.setCotizacion]: setCotizacionState,
    [actions.setBeneficiarioIgualTitularAction]: setBeneficiarioIgualTitular,
    [actions.loadingCotizacion]: (state, { payload }) => ({ ...state, loadingCotizacion: payload }),
  },
  initialState,
);

export default Cotizacion;
